<menu>
    <div>
        <img src="../../assets/logo-s.svg" routerLink="/">
    </div>
    <!-- Hamburger Icon -->
    <div class="hamburger" (click)="toggleMenu()">
        ☰
    </div>
    <!-- Navigation Links -->
    <div class="nav-links" [class.active]="isMenuOpen">
        <ul>
            <li [routerLink]="['/']" fragment="avaliacoes" (click)="closeMenu()">Avaliações</li>
            <li routerLink="assinatura" (click)="closeMenu()">Assinatura</li>
            <li [routerLink]="['/']" fragment="faq" (click)="closeMenu()">FAQ</li>
            <li [routerLink]="['/']" fragment="contato" (click)="closeMenu()">Contato</li>
        </ul>
    </div>
    <!-- Call-to-Action Button -->
    <div class="cta-button">
        <button routerLink="assinatura">
            <img src="../../assets/button-icon.svg">
            Comece agora
        </button>
    </div>
</menu>